import React, { useCallback } from "react";
import { Button, Group, Paper, Stack, Text } from "@mantine/core";
import { ReceivedExternalBadge } from "./ReceivedExternalBadge";

interface Props {
  itemLabel: string;
  lastStickerPrintedAt?: string;
  isReprinted?: boolean;
  canReprint?: boolean;
  onReprintClick: () => void;
  onAcknowledge: () => void;
  isAcknowledgeLoading?: boolean;
}

export const ReceivedExternalPassThroughPanel: React.FC<Props> = ({
  itemLabel,
  lastStickerPrintedAt,
  isReprinted,
  canReprint = true,
  onReprintClick,
  onAcknowledge,
  isAcknowledgeLoading = false,
}) => {
  const handleReprintClick = useCallback(() => {
    onReprintClick();
  }, [onReprintClick]);

  const handleAcknowledge = useCallback(() => {
    onAcknowledge();
  }, [onAcknowledge]);

  return (
    <Paper
      p="sm"
      withBorder
      style={{
        borderLeftWidth: 3,
        borderLeftColor: "var(--mantine-color-violet-5)",
      }}
    >
      <Stack gap="xs">
        <Group justify="space-between">
          <Text size="sm" fw={500}>
            {itemLabel}
          </Text>
          <ReceivedExternalBadge
            isReprinted={isReprinted}
            lastStickerPrintedAt={lastStickerPrintedAt}
          />
        </Group>

        <Text size="xs" c="dimmed">
          This item was received externally — no work is required at this stage.
        </Text>

        <Group gap="xs">
          <Button
            size="xs"
            color="violet"
            disabled={!canReprint}
            onClick={handleReprintClick}
          >
            Reprint Sticker
          </Button>
          <Button
            size="xs"
            variant="subtle"
            loading={isAcknowledgeLoading}
            onClick={handleAcknowledge}
          >
            Acknowledge Pass-Through
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
};
